export enum DocumentType {
  MONTHLY_STATEMENT = "monthly_statement",
  INVESTOR_DOCUMENT = "investor_document",
  TOKEN_DOCUMENT = "token_document",
}

export interface DocumentDto {
  id: string;
  tokenId: string;
  issuerId: string;
  tokenName: string;
  tokenLogoUrl: string;
  issuerLogoUrl: string;
  type: string;
  url: string;
  description: string;
  createdAt: string;
  timestamp: number;
}
